import './ProcessMiddle.scss'

export default function ProcessMiddle(props: any) {
  let height = props?.height;
  let value = (props?.value) | 0;
  let valueShow = props?.valueShow | 0;

  if (!valueShow) {
    valueShow = value
  }

  if (value > 100) {
    value = 0;
  }

  value = value / 2

  return (
    <>
      <div className="YngMhigtBh" style={value > 0 ? { flexDirection: 'row', height: height } : { flexDirection: 'row-reverse', height: height }}>
        <div className={`KasbbIshta ${value > 0 ? 'ZZOKQTnLHn' : 'dRzTBFPSEJ'}`} style={
          {
            width: `${value > 0 ? value : value * -1}%`,
            backgroundColor: value > 0 ? '#22AB24' : '#E31E4D',
          }
        }>
          {value > 0 ? <div className='ymTrfTEbwv' style={{ right: `calc(100% + 3px)`, color: value > 0 ? '#219653' : '#E31E4D' }}>{valueShow}%</div> : null}
          {value < 0 ? <div className='ymTrfTEbwv' style={{ left: `calc(100% + 3px)`, color: value > 0 ? '#219653' : '#E31E4D' }}>{valueShow}%</div> : null}
          {value === 0 ? <div className='ymTrfTEbwv' style={{ left: `calc(100% + 3px)`, color: '#f59700' }}>{valueShow}%</div> : null}
        </div>
      </div>
    </>
  )
}